// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zz4KT","col":"styles_col__3PzRy"};